// Auto-generated lightweight class for SimpleFunctionalDependency
// DO NOT EDIT - Changes will be overwritten

import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { SimpleFunctionalDependencyReadAPI, SimpleFunctionalDependencyWriteAPI, SimpleFunctionalDependencyReadAPISchema, SimpleFunctionalDependencyWriteAPISchema } from '../types/simplefunctionaldependency';
import { ModelRegistry } from '../../registries/model-registry';




export interface SimpleFunctionalDependency extends Partial<SimpleFunctionalDependencyReadAPI> {}
export class SimpleFunctionalDependency extends NeoNodeBase<SimpleFunctionalDependencyReadAPI, SimpleFunctionalDependencyWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "SimpleFunctionalDependency";
  static readonly readSchema = SimpleFunctionalDependencyReadAPISchema;
  static readonly writeSchema = SimpleFunctionalDependencyWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
  };

  protected get modelName(): string {
    return 'SimpleFunctionalDependency';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return SimpleFunctionalDependency.label;
  }


  constructor(data: Partial<SimpleFunctionalDependencyWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: SimpleFunctionalDependencyReadAPI, loadContext?: Record<string, any>): SimpleFunctionalDependency {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = SimpleFunctionalDependencyReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return SimpleFunctionalDependency.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // No relationships to instantiate

    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new SimpleFunctionalDependency(processed as any);

    return instance;
  }


}
